.piaMessage{
    margin-bottom: 10px;    
}

.piaMessageContent{
    max-width: 90%;
    white-space: pre-wrap;
}

.piaMessageText{
    font-size: var(--font-size-lg);
}